import type { ReactElement } from 'react';
import { Button, Group } from '@mantine/core';
import { ChevronRight } from 'lucide-react';
import type { AdoptionScope } from './AdoptionTypes';

interface AdoptionScopeTrailProps {
    path: AdoptionScope[];
    /** Navigate to a truncated path (empty = whole org). */
    onNavigate: (path: AdoptionScope[]) => void;
}

function Crumb({ label, active, onClick }: { label: string; active: boolean; onClick: () => void }): ReactElement {
    return (
        <Button size="compact-sm" radius="md" variant={active ? 'light' : 'default'} color={active ? 'brand' : 'gray'} onClick={onClick} style={{ fontWeight: active ? 700 : 500 }}>
            {label}
        </Button>
    );
}

/** The drill trail as clickable pills: Entire org › Department › Person. Clicking a pill scopes back to that level. */
export default function AdoptionScopeTrail({ path, onNavigate }: AdoptionScopeTrailProps): ReactElement {
    return (
        <Group gap={6} wrap="wrap" align="center">
            <Crumb label="Entire org" active={path.length === 0} onClick={() => onNavigate([])} />
            {path.map((scope, index) => (
                <Group gap={6} key={`${scope.dimension}-${scope.value}`} wrap="nowrap" align="center">
                    <ChevronRight size={14} style={{ color: 'var(--bm-color-text-dimmed)' }} />
                    <Crumb label={scope.label ?? scope.value} active={index === path.length - 1} onClick={() => onNavigate(path.slice(0, index + 1))} />
                </Group>
            ))}
        </Group>
    );
}
